import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

function Accordion({ title, content }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full mb-4 overflow-hidden rounded-xl border border-[#004270]/15 shadow-sm">
      {/* Header */}
      <button
        onClick={() => setOpen(!open)}
        className={`flex w-full items-center justify-between px-6 py-4 text-left transition-all duration-300 ${
          open
            ? "bg-slate-100"
            : "bg-slate-50"
        }`}
      >
        <p className="text-base md:text-lg font-semibold">{title}</p>

        <motion.div
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ duration: 0.25 }}
        >
          {open ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
        </motion.div>
      </button>

      {/* Content */}
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{
              height: "auto",
              opacity: 1,
            }}
            exit={{
              height: 0,
              opacity: 0,
            }}
            transition={{
              duration: 0.35,
              ease: "easeInOut",
            }}
            className="overflow-hidden"
          >
            <div className="bg-white px-6 py-5">
              <div className="prose prose-sm max-w-none text-[#004270] [&_p]:mb-3 [&_li]:mb-2 [&_table]:w-full [&_table]:border [&_table]:border-[#004270] [&_td]:border-b [&_td]:border-[#004270]/20 [&_th]:bg-slate-100 [&_a]:text-[#004270] hover:[&_a]:text-[#febe10]">
                {content}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Accordion;
